import { Tooltips } from "Modules/tooltips";
import { Modals } from "Components/modals";
import * as balanceText from 'Lib/balanceText.js';
//@ts-ignore
import { createApp, App } from "vue";

export namespace GlobalLockDesigner {
	let calculateScrollBarPostion = () => {
		let $el = $('<div style="width: 100%"></div>');
		$el.appendTo('body');
		let constrainedWidth = $el.width();

		$el.css('width', '100vw');
		let fullWidth = $el.width();
		let scrollbarWidth = Math.ceil(fullWidth - constrainedWidth);

		document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
		$el.remove();
	};

	let initializeBalanceText = () => {
		balanceText();
	};

	let setTouchOrNoTouch = () => {
		let isTouchDevice = () => {
			return window.matchMedia("(pointer: coarse)").matches
		}

		if(isTouchDevice()) {
			document.body.classList.add('touch');
			document.body.classList.remove('no-touch');
		} else {
			document.body.classList.remove('touch');
			document.body.classList.add('no-touch');
		}
	}

	//in the backend of sitefinity there is a tray you can close and open for content and layout this determines if it is open or not and adds a class on the body if its open
	//this is useful for configuring styles only for the backend when opened and closed.
	let watchSitefinityBackendTray = () => {
		if(!document.body.classList.contains('sfPageEditor')) {
			return;
		}

		let elementToObserve = null;

		let observeTheElement = () => {
			elementToObserve = document.getElementById("sfHideShowToolbox");
			let checkClassAttribute = (mutation?) => {

				let el = mutation ? mutation.target : elementToObserve;
				if(el.classList.contains('sfHiddenToolbox')) {
					document.body.classList.remove('sfEditorToolboxOpen');
					document.body.classList.add('sfEditorToolboxClosed');
				} else {
					document.body.classList.remove('sfEditorToolboxClosed');
					document.body.classList.add('sfEditorToolboxOpen');
				}
			}
			checkClassAttribute();

			let callback = (mutationList, observer) => {
				mutationList.forEach(function(mutation) {
					switch(mutation.type) {
						case "attributes":
							switch(mutation.attributeName) {
								case "class":
									checkClassAttribute(mutation);
									break;
							}
							break;
					}
				});
			}
			const observer = new MutationObserver(callback);
			observer.observe(elementToObserve, {
				subtree: true,
				attributeFilter: [ "class" ],
				attributeOldValue: true,
			});
		}

		if(!elementToObserve) {
			//The node we need does not exist yet.
			//Wait 500ms and try again
			window.setTimeout(observeTheElement,200);
			return;
		} else {
			observeTheElement();
		}
	}

	/**
	 * Container Initialization
	 */
	export const init = () => {
		setTouchOrNoTouch();
		calculateScrollBarPostion();
		watchSitefinityBackendTray();
		Modals.init();
		Tooltips.init();
		initializeBalanceText();
	}
}

GlobalLockDesigner.init();
